import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const TextIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.5.5h20v20H.5zM8.5 4.5h8M4.5 12.5h12M4.5 8.5h12M4.5 16.5h6.67" />
    </SVG>
  );
};
